import { eACHDisbursementCategories } from './eEscrowAchPushDisbursementCategories';
import { ICreateUpdateACHPushDisbursement } from './IAchPushDisbursementData';
import { IAchAccountData } from './IAchAccountData';

export interface IAchPushFormData {
  id?: string;
  ownerId?: string;
  achAccountId: string;
  amountCents: number;
  category: eACHDisbursementCategories;
  wellsFargoTransactionNumber?: string;
  account?: IAchAccountData;
  cdItemId?: string;
}

export const convertIAchPushFormDataToICreateUpdateACHPushDisbursement = ({
  achAccountId,
  amountCents,
  category,
  wellsFargoTransactionNumber,
  ownerId,
  id,
  account,
  cdItemId,
}: IAchPushFormData): ICreateUpdateACHPushDisbursement => ({
  achAccountId: account?.id || achAccountId,
  amountCents,
  category,
  wellsFargoTransactionNumber,
  ownerId,
  id: id,
  cdItemV3Id: cdItemId,
});
